module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"title":["icon-social--linkedin"],"path":[{"$":{"d":"M19,0H5A5,5,0,0,0,0,5V19a5,5,0,0,0,5,5H19a5,5,0,0,0,5-5V5A5,5,0,0,0,19,0ZM8,19H5V8H8ZM6.5,6.73A1.76,1.76,0,1,1,8.25,5,1.76,1.76,0,0,1,6.5,6.73ZM20,19H17V13.4c0-3.37-4-3.11-4,0V19H10V8h3V9.77c1.4-2.59,7-2.78,7,2.48Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/icon-social--linkedin.svg
// module id = 503
// module chunks = 0